import './i18n.ts';
import { createRoot } from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './app/styles/main.scss'
import { mainRoutes } from "./app/app.tsx";
import './services/REACT_CONFIG.ts';
import { GlobalProvider } from "./services/cartInitContext.tsx";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router";

const langPath = window.location.pathname.split('/');

const router = createBrowserRouter(mainRoutes, {
    basename: `/${langPath[1]}`,
    async patchRoutesOnNavigation({ path, patch }) {
        if (path.startsWith(`${this.basename}/dashboard`)) {
            let module = await import("./app/routes/DashboardRouteLazy.tsx");
            let routes = createRoutesFromElements(module.default)
            patch("dashboard-root", routes);
        }
    },
})

createRoot(document.getElementById('root')!).render(
    <GlobalProvider>
        <RouterProvider router={router} />
        {/* <BrowserRouter basename={"/" + langPath[1]}>
            <ScrollToTop/>
            <App/>
        </BrowserRouter> */}
    </GlobalProvider>
)
